import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundForward } from "react-icons/io";
import sproxillogo from "../../images/headerimges/mis-survey/sproxillogo.png";
import clockIcon from "../../images/headerimges/mis-survey/clock.svg";
import securedIcon from "../../images/headerimges/mis-survey/security.svg";
import { resetState, setRespondent } from "store/features/misSurveySlice";
import { useDispatch, useSelector } from "react-redux";
import solinalogo from "../../images/headerimges/solina/solina-herder.png";
import { useQuery } from "react-query";
import axios from "axios";
import { difference } from "lodash";
import { secureStorage } from "utils/encryptionUtil";
import toast from "react-hot-toast";
import { TextField } from "@mui/material";
import { useGetSurveyCode } from "api/hooks";

const WelcomePPMVPage = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const [btnDisable, setBtnDisable] = useState(true);
	const [shouldValidate, setShouldValidate] = useState(false);

	const [section, setSetion] = useState(null);
	const [surveyCode, setSurveyCode] = useState();
	const [phoneNumber, setPhoneNumber] = useState("");
	const [processedNumber, setProcessedNumber] = useState("");

	const { data, isLoading, isError, isSuccess } = useGetSurveyCode(
		processedNumber,
		shouldValidate,
	);
	useEffect(() => {
		if (isError && !isLoading) {
			toast.error("An error occurred while fetching the survey code.");
            setShouldValidate(false);
		}

		if (isSuccess && data && !isLoading) {
            setShouldValidate(false);
			setSurveyCode(data?.[0]?.survey_code);
		}
	}, [isError, isLoading, data]);

	const isInvalid = phoneNumber.length > 0 && phoneNumber.length !== 11;

	const isButtonDisabled = isLoading || isInvalid || phoneNumber.length <= 0;

	// const proceedToSurvey = () => {
	// 	navigate(`/solina-p`);
	// };
	const { localRespondent } = useSelector((state) => state.misSurvey);

	useQuery({
		queryKey: ["solina-ppmv-history"],
		queryFn: async () => {
			// const code = queryParams.get("c");
			const res = await axios.get(
				`${process.env.REACT_APP_SURVEY_BASE_URL}/survey/code?survey_code=${surveyCode}&survey_id=${process.env.REACT_APP_SOLINA_PPMV_ID}`,
			);
			return res.data.data;
		},
		onSuccess: (data) => {
			const diff = difference(data?.sections, data?.section_history);
			setSetion(diff[0]);
			// diff.shift()
			dispatch(
				setRespondent({
					...localRespondent,
					phone_number: data?.phone_number,
					survey_code: data?.survey_code,
				}),
			);
			secureStorage.setSession("start_section", data?.sections[0]);
			secureStorage.setSession(
				"end_section",
				data?.sections[data?.sections.length - 1],
			);
			secureStorage.setLocal("solinaPPMVHistory", diff);
			// setBtnDisable(false);
			setTimeout(() => {
				navigate("/solina-p");
			}, 400);
		},
		onError: (err) => {
			toast.error("Invalid survey code...");
			console.log(err);
			setBtnDisable(true);
		},
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!surveyCode,
	});

	const handlePhoneInput = (e) => {
		const value = e.target.value;

		// Allow only digits
		if (/^\d*$/.test(value)) {
			setPhoneNumber(value);
		}
	};

	useEffect(() => {
		const shouldReset = queryParams.get("reset");
		if (shouldReset) {
			dispatch(resetState());
		}
	}, []);

	useEffect(() => {
		const agentNumber = queryParams.get("userId") ?? "";
		const surveyChannel = queryParams.get("channel") ?? "";
		const shouldReset = queryParams.get("reset");
		// const urlSurveyCode = queryParams.get("c") ?? "";
		if (surveyCode) {
			secureStorage.setSession("::dc::us-mls", surveyCode);
			secureStorage.setSession("::agent::us-mls", agentNumber);
			secureStorage.setSession("::channel::us-mls", surveyChannel);
		}

		if (shouldReset) {
			sessionStorage.removeItem("persist:smis::heartbeat");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, navigate]);

	const processPhoneNumber = () => {
		const normalizedPhoneNumber = phoneNumber.startsWith("0")
			? `+234${phoneNumber.slice(1)}`
			: phoneNumber;
		setProcessedNumber(normalizedPhoneNumber);

		setShouldValidate(true);
	};

	return (
		<section className={styles.container}>
			<div className={styles.image_wrapper}>
				<img src={sproxillogo} alt="sproxil" />
				<img
					src={solinalogo}
					alt="sproxil"
					style={{ width: "170px" }}
				/>
			</div>

			<div className={styles.introduction_wrapper}>
				<h2>Partnering to Improve Malaria Care</h2>
				<p>
					Please take part in this special survey designed to
					strengthen malaria prevention and treatment in your
					community. As a trusted PPMV or pharmacy, your participation
					will:
				</p>
				<div style={{ fontSize: 14 }}>
					<h2>
						<b>
							<i>
								Provide insights into the services you offer for
								malaria testing and treatment. Help track the
								availability and use of malaria diagnostics and
								medicines Contribute to shaping better
								strategies for malaria control in your community
							</i>
						</b>
					</h2>

					<p>
						Your input will guide state malaria programs and ensure
						that private-sector providers like you are recognized as
						key partners in the fight against malaria.
					</p>
					<h3>
						As appreciation for your time, you will receive airtime
						credit after completing the survey.
					</h3>
					<span>
						Your answers are completely confidential and will only
						be used for improving malaria care.
					</span>
				</div>

				<section className={styles.introduction_icons}>
					<div className={styles.survey_icon_summary}>
						<img src={clockIcon} alt="fast survey" />
						<p>
							Quick <span>10-minute</span> survey
						</p>
					</div>
					<div className={styles.survey_icon_summary}>
						<img src={securedIcon} alt="fast survey" />
						<p>
							100% <span>confidential responses</span>
						</p>
					</div>
				</section>

				<div className="mt-10">
					<TextField
						id="mainText"
						label="Enter your phone number"
						placeholder="e.g 08123456789"
						variant="outlined"
						size="small"
						className="w-full"
						value={phoneNumber}
						onChange={handlePhoneInput}
						data-testid="textbox_input"
						slotProps={{
							htmlInput: {
								inputMode: "numeric",
								pattern: "[0-9]*",
								maxLength: 11,
								minLength: 11,
							},
						}}
						error={isInvalid}
						helperText={
							isInvalid ? "Phone number must be 11 digits" : ""
						}
					/>
					<small className="my-4">
						Please enter your phone number to proceed
					</small>
					<button
						className="primary-btn mt-5"
						onClick={processPhoneNumber}
						disabled={isButtonDisabled}
					>
						{isLoading ? "loading" : "confirm phone number"}
					</button>
				</div>
			</div>
		</section>
	);
};

export default WelcomePPMVPage;
